import { WorkQueueDetails, WorkQueueState } from '@core/services/work-queue/work-queue.model';
import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromRoot from '../../../features.state';
import * as lenderReconciliationQueueActions from './lenderreconciliation-queue.actions';

export interface AppState extends fromRoot.FeaturesState {
  lenderreconciliationstate: WorkQueueState;
}

export const lenderReconciliationAdapter: EntityAdapter<WorkQueueDetails> = createEntityAdapter<WorkQueueDetails>();

export const defaultLenderReconciliation: WorkQueueState = {
  ids: [],
  entities: {},
  selectedId: null,
  loading: false,
  loaded: false,
  error: '',
};

export const initialState = lenderReconciliationAdapter.getInitialState(defaultLenderReconciliation);

export function LenderReconciliationQueueReducer(
  state = initialState,
  action: lenderReconciliationQueueActions.LenderReconciliationQueueAction
): WorkQueueState {
  switch (action.type) {
    case lenderReconciliationQueueActions.LenderReconciliationQueueActionTypes.LOAD_LENDERRECONCILIATIONQUEUE_SUCCESS: {
      return lenderReconciliationAdapter.addOne(action.payload, {
        ...state,
        selectedId: action.payload.id,
      });
    }

    case lenderReconciliationQueueActions.LenderReconciliationQueueActionTypes.LOAD_LENDERRECONCILIATIONQUEUE_FAIL: {
      return {
        ...state,
        error: action.payload,
      };
    }

    default: {
      return state;
    }
  }
}

const getLenderReconciliationQueueState = createFeatureSelector<WorkQueueState>('lenderReconciliationQueue');

export const getLenderReconciliationQueue = createSelector(
  getLenderReconciliationQueueState,
  lenderReconciliationAdapter.getSelectors().selectAll
);

export const getLenderReconciliationQueueLoading = createSelector(
  getLenderReconciliationQueueState,
  (state: WorkQueueState) => state.loading
);

export const getLenderReconciliationQueueLoaded = createSelector(
  getLenderReconciliationQueueState,
  (state: WorkQueueState) => state.loaded
);

export const getError = createSelector(
  getLenderReconciliationQueueState,
  (state: WorkQueueState) => state.error
);

export const getCurrentLenderReconciliationQueueId = createSelector(
  getLenderReconciliationQueueState,
  (state: WorkQueueState) => state.selectedId
);

export const getCurrentLenderReconciliationQueue = createSelector(
  getLenderReconciliationQueueState,
  getCurrentLenderReconciliationQueueId,
  state => state.entities[state.selectedId]
);
